import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/hotels")({
  component: RouteComponent,
  beforeLoad: () => {
    return { title: "Hotels" };
  },
});

function RouteComponent() {
  return (
    <>
      <Outlet />
    </>
  );
}
